export default {

    newScope: 'New Scope',
    areasProcess: 'Organizational Areas and Processes',
    noAreasProcesses: 'Organizational processes not found',
    noAreaProcess: 'Organizational process not found',
    ubication: 'Location',
    interestedParties: 'Interested Parties',
    notes: 'Notes',
    createScope: 'Create Scope',
    editScope: 'Edit Scope',
    getScopeError: 'Error retrieving scope',
    editScopeError: 'An error occurred while editing the scope',
    createScopeError: 'An error occurred while creating the scope',
    editScopeSuccess: 'Scope edited successfully',
    createScopeSuccess: 'Scope created successfully',
    systemConfigurationPlaceHolder: 'System Configuration',
    interestedPartiesPlaceHolder: 'Interested parties... 0/500',
    notesPlaceHolder: 'Notes 0/500',
    descriptionPlaceHolder: 'Description 0/500',
    scopes: 'Scopes',
    scope: 'Scope',
    status: 'Status',
    getScopesError: 'An error occurred while retrieving scopes: ',
    deleteScopeError: 'An error occurred while deleting the scope: ',
    deleteScopeSuccess: 'Scope deleted successfully',
    scopeDetail: 'View Scope Detail',
    editScopeLoader: 'Editing scope...',
    createScopeLoader: 'Creating scope...',
    deleteLoader: 'Deleting scope...',
    selectScope: 'Select a scope to continue',
    whatIsScope: 'What is a Scope?',
    scopeGuide: 'allows you to define the boundaries of your risk analysis, i.e. what will you perform a risk analysis on. You can select the default scope and edit it later or you can create your own scope. Next we will go to impact creation',
    scopeExampleSecurity: 'Technology Infrastructure Security',
    scopeExampleSensibleData: 'Sensitive Data Protection',
    scopeExampleWebSecurity: 'Web Application Risk Assessment',
    scopeExamples: 'Examples:',
    ScopeNoEliminable: 'This scope cannot be deleted, you must change the scope first',
    areasProcessesTooltip: 'Select one or more organizational processes. This field is required.',
    welcomeToScopesSection: 'Welcome to the Scopes section!',
    defineFirstScopeMessage: 'We are glad you are here. Before you start, define your first scope to effectively manage information security risks.',
    endDate: 'End date:',
    createFirstCope: 'I want to create my first risk analysis scope',
    createNewOrganizationalProcess: 'Create New Organizational Process',
    interestedPartiesTooltip: 'Internal and external (Employees, Shareholders, owners and senior management, Government agencies with regulatory authority, Customers, Suppliers, Partners and contractors)',
    validityStartDate: 'Start of Validity:',
    validityEndDate: 'End of Validity:',

};